/** Public iOS listing. Verified live as QLS Global 1.0.1. */
export const APP_STORE_URL = 'https://apps.apple.com/us/app/qls-global/id6806108135';

/** Public Play listing. Production 0.1.0 is live. */
export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=io.quantumloc.global';

export const DOWNLOAD_PAGE_PATH = '/get-app';

export const APP_DOWNLOAD_DISMISS_KEY = 'qls-app-download-dismissed';
export const APP_DOWNLOAD_DISMISS_MS = 7 * 24 * 60 * 60 * 1000;

export type AppStoreKind = 'ios' | 'android';
export type AppStoreAudience = 'ios' | 'android' | 'desktop';

export const APP_STORES: Record<
  AppStoreKind,
  { available: boolean; url: string; label: string; comingSoonLabel: string }
> = {
  ios: {
    available: true,
    url: APP_STORE_URL,
    label: 'Download on the App Store',
    comingSoonLabel: 'iPhone app coming soon',
  },
  android: {
    available: true,
    url: PLAY_STORE_URL,
    label: 'Get it on Google Play',
    comingSoonLabel: 'Android app coming soon',
  },
};

export const isStoreLive = (store: AppStoreKind): boolean => APP_STORES[store].available;

export function detectDevice({
  userAgent = '',
  platform = '',
  maxTouchPoints = 0,
}: {
  userAgent?: string;
  platform?: string;
  maxTouchPoints?: number;
} = {}): AppStoreAudience {
  if (/iPhone|iPad|iPod/i.test(userAgent) || (/Mac/i.test(platform) && maxTouchPoints > 1)) {
    return 'ios';
  }
  if (/Android/i.test(userAgent)) {
    return 'android';
  }
  return 'desktop';
}

export function getDownloadPageUrl(): string {
  if (typeof window === 'undefined') {
    return DOWNLOAD_PAGE_PATH;
  }
  return `${window.location.origin}${DOWNLOAD_PAGE_PATH}`;
}

const PROMPT_PATHS = new Set(['/', '/search', '/faq', '/support']);

export function isDownloadPromptPage(pathname: string): boolean {
  const path = pathname.replace(/\/+$/, '') || '/';
  return PROMPT_PATHS.has(path);
}

export function canShowDownloadPrompt({
  pathname,
  device,
  standalone,
  dismissedAt,
  now = Date.now(),
}: {
  pathname: string;
  device: AppStoreAudience;
  standalone: boolean;
  dismissedAt?: string | null;
  now?: number;
}): boolean {
  if (standalone || !isDownloadPromptPage(pathname)) {
    return false;
  }
  // Phone visitors with no live store should not be pushed toward a dead listing.
  if (device !== 'desktop' && !APP_STORES[device]?.available) {
    return false;
  }
  const timestamp = Number(dismissedAt);
  if (Number.isFinite(timestamp) && timestamp > 0 && now - timestamp < APP_DOWNLOAD_DISMISS_MS) {
    return false;
  }
  return true;
}
